export class PagedListGenericResponse<T> {
  data: Array<T>;
  count: number;
  total: number;
  page: number;
  pageCount: number;
}
